import navMasterData from "./nav-master-data";
import navPartner from "./nav-partner";
import navPengaturan from "./nav-pengaturan";
import navSistemKerjasama from "./nav-sistem-kerjasama";

const navigation = [
  navSistemKerjasama,
  navPartner,
  navMasterData,
  navPengaturan,
];

export default navigation;